function paraData (valor?: string): Date | undefined {
  if (!valor) return undefined

  const data = new Date(valor)

  return isNaN(data.getTime()) ? undefined : data
}

export function formatarDataHora (valor?: string): string | undefined {
  const data = paraData(valor)

  if (!data) return undefined

  const dia = String(data.getDate()).padStart(2, '0')
  const mes = String(data.getMonth() + 1).padStart(2, '0')
  const hora = String(data.getHours()).padStart(2, '0')
  const minuto = String(data.getMinutes()).padStart(2, '0')

  return `${dia}/${mes}/${data.getFullYear()} às ${hora}:${minuto}`
}

export function dataExpirou (valor?: string): boolean {
  const data = paraData(valor)

  return data !== undefined && data.getTime() < Date.now()
}

export function ordenarPorDataSolicitacao<T extends { dataSolicitacao?: string }> (itens: T[]): T[] {
  // Registros anteriores ao snapshot nao tem data, entao caem para a ordem de insercao
  return itens
    .map((item, indice) => ({ item, indice }))
    .sort((a, b) => {
      const dataA = paraData(a.item.dataSolicitacao)?.getTime()
      const dataB = paraData(b.item.dataSolicitacao)?.getTime()

      // Comparador precisa ser total: sem isso a ordem varia ao misturar registros com e sem data
      if (dataA === undefined && dataB === undefined) return a.indice - b.indice
      if (dataA === undefined) return -1
      if (dataB === undefined) return 1

      return dataA - dataB || a.indice - b.indice
    })
    .map(({ item }) => item)
}
